import { Checkbox, Chip } from '@mui/material';
import { PropsWithChildren } from 'react';

import { SearchRefinementListItemStyled } from './SearchRefinementListItem.styled';
import { SearchRefinementListItemProps } from './SearchRefinementListItem.types.ts';
import { SearchRefinementListTypographyStyled } from './SearchRefinementListTypography.styled';

export const SearchRefinementListItem = ({
  item,
  refine,
  children,
}: PropsWithChildren<SearchRefinementListItemProps>) => {
  return (
    <SearchRefinementListItemStyled>
      <Checkbox checked={item.isRefined} onChange={() => refine(item.value)} />
      <SearchRefinementListTypographyStyled variant="subtitle2" paddingRight={1}>
        {children ?? item.label}
      </SearchRefinementListTypographyStyled>
      <Chip label={item.count} size="small" />
    </SearchRefinementListItemStyled>
  );
};
